<template>
    <div class="bg-background min-h-screen font-sans text-text">
        <HeroSection v-if="!authStore.isLoggedIn" />
        <CarteEtClassement />
        <StepsSection v-if="!authStore.isLoggedIn" />
        <!--<PortraitsSection />-->
    </div>
</template>

<script setup>
import HeroSection from '@/components/home/HeroSection.vue'
import CarteEtClassement from '@/components/home/CarteEtClassement.vue'
import StepsSection from '@/components/home/StepsSection.vue'
//import PortraitsSection from '@/components/home/PortraitsSection.vue'
import { useAuthStore } from '@/stores/authStore'

const authStore = useAuthStore()
</script>
